import React, { useMemo } from "react"

import { EntityTable } from "../../../../components/EntityTable/EntityTable.tsx"
import {
  DEFAULT_TAB,
  TABLE_SURFACES
} from "../../../../components/EntityTable/surfaces.ts"
import { TableResultCount } from "../../../../components/Table/TableResultCount.tsx"
import { useInfiniteScroll } from "../../../../hooks/use-table-infinite-scroll.tsx"
import type { Lead } from "../../../Lead/types/lead.types.ts"
import { getColumns } from "./columns.tsx"

interface LeadsApprovalListProps {
  leads: Lead[]
  loading: boolean
  saving: boolean
  next?: string | null
  retryNext?: string | null
  total: number
  onLoadMore: () => void
  onSelectRow: (lead: Lead, active: string) => void
}

export default function LeadsApprovalList({
  leads,
  loading,
  saving,
  next,
  retryNext,
  total,
  onLoadMore,
  onSelectRow
}: LeadsApprovalListProps) {
  const columns = useMemo(
    () => getColumns({ onSelectRow, saving }),
    [onSelectRow, saving]
  )

  const { onTableScroll, containerRef } = useInfiniteScroll({
    loading,
    hasMore: !!next,
    loadMoreKey: next,
    loadMore: onLoadMore
  })

  return (
    <div ref={containerRef}>
      <EntityTable
        surface={TABLE_SURFACES.leadsApproval}
        selectionMode="on-demand"
        tab={DEFAULT_TAB}
        scroll={{ x: "max-content", y: 480 }}
        dataSource={leads}
        columns={columns}
        rowKey="id"
        rowHoverable={false}
        onScroll={onTableScroll}
        withOutPagination
        pagination={false}
        className="mb-8"
        loading={loading && !leads?.length}
      />
      <TableResultCount
        loaded={leads?.length ?? 0}
        total={total}
        loading={loading}
        next={next}
        retryNext={retryNext}
        onRetry={onLoadMore}
      />
    </div>
  )
}
